import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpdate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.24024 1.53688C10.1142 0.66279 11.5313 0.662752 12.4054 1.53679C13.2793 2.41074 13.2793 3.8277 12.4054 4.70172L11.8477 5.25956L8.68262 2.09454L9.24024 1.53688ZM8.01931 2.75794L1.76646 9.01153C1.51234 9.2657 1.33372 9.58535 1.25047 9.93496L0.565273 12.8128C0.527548 12.9713 0.574723 13.138 0.6899 13.2531C0.805083 13.3683 0.97177 13.4155 1.13023 13.3778L4.00793 12.6926C4.35766 12.6093 4.67742 12.4306 4.93163 12.1764L11.1844 5.92296L8.01931 2.75794Z",
		fill: "currentColor"
	})
});
export default SvgUpdate;
